// src/components/common/DateRangeTags.jsx
import React, { Component } from 'react';
import '../../styles/components/date-range-tags.scss';
import i18n from '../../i18n';

const DEFAULT_TAGS = [
  { key: '7', label: i18n.t('last_7_days') },
  { key: '30', label: i18n.t('last_30_days') },
  { key: '365', label: i18n.t('last_1_year') },
  { key: 'custom', label: i18n.t('custom') },
];

const DEFAULT_FORMAT = (d) => d.toISOString().split('T')[0];

class DateRangeTags extends Component {
  static defaultProps = {
    tags: DEFAULT_TAGS,
    formatDate: DEFAULT_FORMAT,
  };

  // ── Static: callable without an instance (used by consumers on mount) ──────
  static resolveRange(key, formatDate = DEFAULT_FORMAT) {
    const today = new Date();

    if (key === '7') {
      const from = new Date(today);
      from.setDate(today.getDate() - 6);
      return { startDate: formatDate(from), endDate: formatDate(today) };
    }

    if (key === '30') {
      const from = new Date(today);
      from.setDate(today.getDate() - 29);
      return { startDate: formatDate(from), endDate: formatDate(today) };
    }

    if (key === '365') {
      const from = new Date(today);
      from.setDate(today.getDate() - 364);
      return { startDate: formatDate(from), endDate: formatDate(today) };
    }

    // 'custom' or any unknown key — no automatic range
    return { startDate: '', endDate: '' };
  }

  // ── Instance: delegates to static, passing the prop formatter ──────────────
  resolveRange(key) {
    return DateRangeTags.resolveRange(key, this.props.formatDate);
  }

  handleClick = (key) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(key, this.resolveRange(key));
    }
  };

  render() {
    const { activeTag, tags } = this.props;

    return (
      <div className="date-range-tags">
        {tags.map(({ key, label }) => {
          const active = activeTag === key;
          return (
            <button
              type="button"
              key={key}
              className={`date-range-tag ${active ? 'date-range-tag--active' : ''}`}
              onClick={() => this.handleClick(key)}
            >
              {label}
            </button>
          );
        })}
      </div>
    );
  }
}

export default DateRangeTags;
